import React, { useState } from 'react';
import api from '../../services/api';

export default function ScanIn() {
  const [tracking, setTracking] = useState('');
  const [parcel, setParcel] = useState(null);
  const [weight, setWeight] = useState('');
  const [pinInput, setPinInput] = useState('');
  const [msg, setMsg] = useState('');

  const lookup = async () => {
    setMsg(''); setParcel(null);
    try {
      const res = await api.get(`/parcels/track/${tracking}`);
      const full = await api.get(`/parcels`);
      const p = full.data.find(x => x.tracking_number === tracking);
      setParcel(p || res.data.parcel);
    } catch (e) { setMsg(e.response?.data?.error || 'Not found'); }
  };

  const receiveOrigin = async () => {
    try {
      await api.post(`/parcels/${parcel.id}/receive-origin`, { actual_weight_kg: weight ? Number(weight) : undefined });
      setMsg(`Received. Status: received_origin. Ready to Sort.`);
      lookup();
    } catch (e) { setMsg(e.response?.data?.error || 'Error'); }
  };

  const sort = async () => {
    try {
      await api.post(`/parcels/${parcel.id}/sort`);
      setMsg(`Sorted. Ready for Dispatch.`);
      lookup();
    } catch (e) { setMsg(e.response?.data?.error || 'Error'); }
  };

  const receiveDestination = async () => {
    try {
      await api.post(`/parcels/${parcel.id}/receive-destination`);
      setMsg(`Received at destination.`);
      lookup();
    } catch (e) { setMsg(e.response?.data?.error || 'Error'); }
  };

  const collectAtHub = async () => {
    if (!pinInput || pinInput.length !== 4) return setMsg('Enter 4-digit PIN');
    try {
      await api.post(`/parcels/${parcel.id}/collect-at-hub`, { pin: pinInput });
      setMsg(`✓ Handed to receiver. Parcel completed.`);
      setPinInput('');
      lookup();
    } catch (e) { setMsg(e.response?.data?.error || 'Error'); }
  };

  return (
    <div>
      <h1>Scan In</h1>
      <div className="card">
        <label className="label">Tracking Number</label>
        <div style={{ display: 'flex', gap: 8 }}>
          <input className="input" style={{ marginBottom: 0 }} value={tracking} onChange={e => setTracking(e.target.value.toUpperCase())} placeholder="SDX-2026-000001" autoFocus onKeyDown={e => e.key === 'Enter' && lookup()} />
          <button className="btn btn-primary" onClick={lookup}>Lookup</button>
        </div>
        {msg && <p style={{ marginTop: 12, color: msg.includes('Error') || msg.includes('not') ? '#dc2626' : '#16a34a' }}>{msg}</p>}
      </div>

      {parcel && (
        <div className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
            <div>
              <div className="label">Tracking</div>
              <strong>{parcel.tracking_number}</strong>
            </div>
            <div>
              <div className="label">Status</div>
              <strong style={{ color: '#dc2626', textTransform: 'uppercase' }}>{parcel.status?.replace(/_/g, ' ')}</strong>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, fontSize: 13 }}>
            <div><div className="label">Sender</div>{parcel.sender_name} · {parcel.sender_phone}</div>
            <div><div className="label">Receiver</div>{parcel.receiver_name} · {parcel.receiver_phone}</div>
            <div><div className="label">Description</div>{parcel.description}</div>
            <div><div className="label">Delivery</div>{parcel.delivery_option === 'hub_pickup' ? '🏪 Hub Pickup' : '🏠 Home Delivery'}</div>
          </div>

          {['booked','collected'].includes(parcel.status) && (
            <div style={{ marginTop: 20, paddingTop: 20, borderTop: '1px solid #e5e7eb' }}>
              <label className="label">Actual weight (kg)</label>
              <input className="input" type="number" step="0.01" value={weight} onChange={e => setWeight(e.target.value)} />
              <button className="btn btn-primary" onClick={receiveOrigin}>Receive at Hub</button>
            </div>
          )}
          {parcel.status === 'received_origin' && (
            <div style={{ marginTop: 20, paddingTop: 20, borderTop: '1px solid #e5e7eb' }}>
              <button className="btn btn-primary" onClick={sort}>Mark Sorted (ready for dispatch)</button>
            </div>
          )}
          {parcel.status === 'in_transit' && (
            <div style={{ marginTop: 20, paddingTop: 20, borderTop: '1px solid #e5e7eb' }}>
              <button className="btn btn-primary" onClick={receiveDestination}>Receive at Destination Hub</button>
            </div>
          )}
          {parcel.status === 'ready_for_pickup' && (
            <div style={{ marginTop: 20, paddingTop: 20, borderTop: '1px solid #e5e7eb', background: '#f0fdf4', padding: 16, borderRadius: 8 }}>
              <h3 style={{ marginTop: 0, color: '#166534' }}>🏪 Ready for Pickup</h3>
              <p style={{ fontSize: 13, color: '#374151' }}>Ask receiver for the 4-digit PIN they received by SMS.</p>
              <input
                className="input"
                inputMode="numeric"
                maxLength={4}
                placeholder="4-digit PIN"
                value={pinInput}
                onChange={e => setPinInput(e.target.value.replace(/\D/g, '').slice(0, 4))}
                style={{ fontSize: 24, letterSpacing: 8, textAlign: 'center', fontWeight: 700 }}
              />
              <button className="btn btn-primary" style={{ width: '100%' }} onClick={collectAtHub}>Verify PIN & Hand Over</button>
            </div>
          )}
          {['delivered','collected_at_hub','cancelled','lost'].includes(parcel.status) && (
            <div style={{ marginTop: 20, paddingTop: 20, borderTop: '1px solid #e5e7eb', color: '#6b7280', fontStyle: 'italic' }}>
              This parcel is in a terminal state — no further action.
            </div>
          )}
        </div>
      )}
    </div>
  );
}
